import { getUserId } from '../tools/utils';
export var actionName;
(function (actionName) {
    actionName["rename"] = "rename";
    actionName["delete"] = "delete";
})(actionName || (actionName = {}));
export var renameAction = {
    name: actionName.rename,
    path: 'doc_changetitle'
};
export var deleteAction = {
    name: actionName.delete,
    path: 'doc_delete'
};
var Change = /** @class */ (function () {
    function Change(globalId, action, from, to, item) {
        this.uid = getUserId();
        this.key = globalId + action.name;
        this.globalId = globalId;
        this.action = action;
        this.from = from;
        this.to = to;
        this.retries = 0;
        this.padInfo = item;
    }
    return Change;
}());
export default Change;
export { Change };
//# sourceMappingURL=Change.js.map